import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
} from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";
import { CustomTable } from "../../../shared";
import { ChevronRight } from "@mui/icons-material";

export const RolePermissionList = (props) => {
  const { state, handleChecked, handleIndeterminate } = props;
  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.display({
      id: "index",
      meta: {
        align: "center",
        width: "20px",
        padding: 0,
        paddingLeft: "4px",
      },
      cell: (props) => {
        const { row } = props;
        return (
          !row.depth && (
            <IconButton
              onClick={() => row.toggleExpanded()}
              size="small"
              sx={{
                rotate: row.getIsExpanded() ? "90deg" : "0deg",
                transition: "0.3s all",
              }}
            >
              <ChevronRight fontSize="small" />
            </IconButton>
          )
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Permission Name",
      cell: (props) => {
        const { row } = props;
        return !row.depth ? (
          <Typography
            fontWeight={500}
            fontSize="14px"
            onClick={() => row.toggleExpanded()}
            sx={{ cursor: "pointer" }}
          >
            {row.original.name}
          </Typography>
        ) : (
          <Typography fontSize="14px" fontWeight={400}>
            {row.original.display_name}
          </Typography>
        );
      },
    }),
    columnHelper.display({
      id: "actions",
      header: () => (
        <FormControlLabel
          sx={{ width: "18px", height: "18px" }}
          control={
            <Checkbox
              checked={handleChecked(2, null, null)}
              indeterminate={handleIndeterminate(2, null)}
              disabled
              size="small"
              color="primary"
              sx={{
                "& .MuiSvgIcon-root": {
                  fontSize: 24,
                },
              }}
              onChange={() => {}}
            />
          }
        />
      ),
      meta: { align: "center", width: "20px" },
      cell: (props) => {
        const { row } = props;
        return (
          <FormControlLabel
            sx={{ width: "18px", height: "18px" }}
            control={
              <Checkbox
                checked={handleChecked(
                  row.depth,
                  row.original.id,
                  row.originalSubRows,
                )}
                indeterminate={
                  !row.depth
                    ? handleIndeterminate(row.depth, row.originalSubRows)
                    : false
                }
                disabled
                size="small"
                color="primary"
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 24,
                  },
                }}
                onChange={() => {}}
              />
            }
          />
        );
      },
    }),
  ];

  return (
    <CustomTable
      columns={columns}
      defaultData={state?.allPermissionsList ?? []}
      isPagination={false}
      showSearchBar={false}
      subRow="permissions"
      manualPagination={true}
      headerText="Permissions"
      tableHeaderStyles={{
        fontSize: "18px",
        px: 0,
        borderBottom: 1,
        borderColor: "divider",
        borderRadius: 0,
      }}
      enableTableContainerPaddingBottom
    />
  );
};
